import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { EMPTY, finalize, forkJoin, map, Observable, switchMap, tap } from 'rxjs';
import { DatePipe } from '@angular/common';
import { CaseApiService } from '../../service/case-api.service';
import { TemplateMapService } from 'src/app/shared/services/template-map.service';
import { DialogService } from 'src/app/core/services/dialog.service';
import { CivilCaseModel } from 'src/app/shared/models/civil-case.model';
import { CaseConfigTab } from 'src/app/shared/models/case-config-tab.model';
import { SnackbarService } from 'src/app/core/services/snackbar.service';

@Injectable({ providedIn: 'root' })
export class CivilCaseResolver implements Resolve<CivilCaseModel | null> {
  static providers = [DatePipe];
  constructor(
    private service: CaseApiService,
    // private layoutState: LayoutState,
    private templateMapService: TemplateMapService,
    private dialog: DialogService,
    private router: Router,
    private snackbarService: SnackbarService
  ) {
    // this.layoutState.setLoadingStatus(true);
  }

  resolve(route: ActivatedRouteSnapshot): Observable<CivilCaseModel | null> {
    const caseId = route.paramMap.get('caseId');
    if (!caseId) {
      // this.layoutState.setLoadingStatus(false);
      return EMPTY;
    }

    return this.service.checkCaseAccessAuthorization(caseId).pipe(
      map((response: any) => JSON.parse(response)),
      switchMap(caseAccessRes => {
        if (caseAccessRes?.IsAuthorizedErrorShow === true) {
          this.snackbarService.showError('You are not authorized to access this case');
          // this.layoutState.setLoadingStatus(false);
          this.router.navigate(['/']);
          return EMPTY;
        }

        return forkJoin([
          this.service.getCivilCaseConfigs({ caseId }),
          this.service.getUserDefineCaseConfigControlsData({ caseId }),
          this.service.getCaseConfigControlsData({ caseId }),
        ]).pipe(
          tap(([config, userDefinedFields, data]) =>
            // this.layoutState.setHeaderTitle(config.templateTitle)
            config.templateTitle
          ),
          tap(([config, userDefinedFields, data]) => {
            if (data.isShowBond) {
              config.tabs.push(<CaseConfigTab>{ identifier: 'BOND' });
            }
          }),
          map(
            ([config, userDefinedFields, data]) =>
              <CivilCaseModel>{
                id: caseId,
                templateId: config.templateId,
                templateTitle: config.templateTitle,
                sections: config.sections.map(section => ({
                  ...section,
                  width: section.id.includes('P') ? `col-${section.width}` : `${section.width}fr`,
                  fields: config.fields
                    .filter(field => field.sectionId === section.id)
                    .map(field =>
                      this.templateMapService.mapField(caseId, field, data, userDefinedFields)
                    )
                    .sort((field1, field2) => field1.order - field2.order),
                })),
                tabs: config.tabs.map(t => this.templateMapService.mapTab(t)).filter(t => !!t),
                caseStatus: data.status,
                docCategory: data.docCategory,
              }
          ),
          finalize(() => { }
            // () => this.layoutState.setLoadingStatus(false)
          )
        );
      }),
      finalize(() => { }
        // this.layoutState.setLoadingStatus(false)
      )
    );
  }
}
